// modules/expanding-cards.js

/**
 * Gestisce il toggle delle expanding-cards:
 * - aggiunge/rimuove classi `.is-active` e `.is-collapsed`
 * - aggiorna aria-expanded
 * - chiude eventuali altre card aperte nello stesso gruppo
 * - funziona con eventi delegati
 * - non gestisce lo swiper, che va inizializzato a parte → vedi modulo expanding-cards-swiper.js
 * - non gestisce l'altezza delle card, che va gestita a parte → vedi campo ACF e modulo equal-grid-height-headers.js
 * - non gestisce animazioni, che vanno gestite a parte → vedi SCSS
 * 
 */

export function initExpandingCards() {
    const grids = document.querySelectorAll("[data-expanding-cards]");
    if (!grids.length) {
        console.warn("[expanding-cards] Nessun gruppo trovato sulla pagina.");
        return;
    }

    console.log(`[expanding-cards] Inizializzazione di ${grids.length} gruppo/i.`);

    grids.forEach((grid, i) => {

        console.log(`[expanding-cards] Setup gruppo #${i + 1}`, grid);

        grid.addEventListener("click", (e) => {
            const btn = e.target.closest(".expanding-cards__trigger");
            if (!btn) return;

            const item = btn.closest(".expanding-cards__item");
            const panel = item.querySelector(".expanding-cards__panel");
            if (!item || !panel) return;

            // Chiudi eventuali altri attivi nello stesso gruppo
            grid.querySelectorAll(".expanding-cards__item.is-active").forEach((active) => {
                if (active !== item) {
                    active.classList.remove("is-active");
                    const b = active.querySelector(".expanding-cards__trigger");
                    const p = active.querySelector(".expanding-cards__panel");
                    if (b) b.setAttribute("aria-expanded", "false");
                    if (p) p.classList.add("is-collapsed");
                    console.log("[expanding-cards] → Chiusura altra card attiva");
                }
            });

            // Toggle card corrente
            const isActive = item.classList.contains("is-active");
            item.classList.toggle("is-active", !isActive);
            btn.setAttribute("aria-expanded", String(!isActive));
            panel.classList.toggle("is-collapsed", isActive);
            console.log(`[expanding-cards] Toggle card: ora ${!isActive ? "aperta" : "chiusa"}`);
        });
    });
}
